import { buildApiUrl } from './axiosClient';

export function logout() {
  window.location.replace(buildApiUrl(process.env.REACT_APP_LOGOUT_PAGE as string));
}